import Router, { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Loading } from '@/components/Loading'
import { useClientOnly } from '@/hooks/useClientOnly'
import { useQuery } from '@/hooks/useQuery'
import { graphql } from '@/school-gql'

interface Props {
  children: React.ReactNode
}

const SCHOOL_ADMIN_PASSWORD_CHANGE_PATH = '/web/school-admin/password_change'

export const SchoolAdminForcePasswordChangeGuard = ({
  children,
}: Props): JSX.Element => {
  useClientOnly()

  const router = useRouter()
  const [{ data }] = useQuery({
    query: SchoolAdminForcePasswordChangeGuardQuery,
    requestPolicy: 'network-only',
  })

  const forcePasswordChange = data.viewer?.forcePasswordChange ?? false
  const isPasswordChangePage =
    router.pathname === SCHOOL_ADMIN_PASSWORD_CHANGE_PATH

  useEffect(() => {
    if (forcePasswordChange && !isPasswordChangePage) {
      Router.replace({
        pathname: SCHOOL_ADMIN_PASSWORD_CHANGE_PATH,
        query: { forcePasswordChange: '1' },
      })
    }
  }, [forcePasswordChange, isPasswordChangePage])

  if (forcePasswordChange && !isPasswordChangePage) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    )
  }

  return <>{children}</>
}

const SchoolAdminForcePasswordChangeGuardQuery = graphql(`
  query SchoolAdminForcePasswordChangeGuardQuery {
    viewer {
      id
      forcePasswordChange
    }
  }
`)
